module.exports = __webpack_public_path__ + "img/camera_small_disabled.fed11c0e.svg";